import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useCallback } from 'react';
import { shareApi } from '../../api/client';
import styles from '../../styles/Share.module.css';
export function ShareButton({ type, achievementId, className }) {
    const [state, setState] = useState('idle');
    const [shareUrl, setShareUrl] = useState('');
    const handleShare = useCallback(async () => {
        if (state === 'loading')
            return;
        setState('loading');
        try {
            const result = type === 'profile'
                ? await shareApi.shareProfile()
                : await shareApi.shareAchievement(achievementId);
            setShareUrl(result.url);
            await navigator.clipboard.writeText(result.url);
            setState('copied');
            setTimeout(() => setState('idle'), 3000);
        }
        catch {
            setState('error');
            setTimeout(() => setState('idle'), 3000);
        }
    }, [type, achievementId, state]);
    const label = state === 'loading' ? '...'
        : state === 'copied' ? '✓ Скопировано'
            : state === 'error' ? 'Ошибка'
                : '📤 Поделиться';
    return (_jsxs("div", { className: `${styles.shareContainer} ${className ?? ''}`, children: [_jsx("button", { className: `${styles.shareBtn} ${state === 'copied' ? styles.copied : ''}`, onClick: handleShare, disabled: state === 'loading', "data-testid": "share-button", children: label }), shareUrl && state === 'copied' && (_jsx("div", { className: styles.shareUrl, "data-testid": "share-url", children: shareUrl }))] }));
}
